<template lang="pug">
#cadastro-operacao
    div(v-show='mostrarFormulariosOperacao')
        BaseHeader(
            :titulo='identificarTituloCadastroOuEdicao()',
            :voltarPara='true',
            :exibeBotao='false'
        )

        .view-container-base-header
            FormularioDadosGeraisOperacao.mb-3(
                v-if='verificouSeEcadastroOuEdicao',
                ref='refFormularioDadosGerais',
                @dadosGerais='atualizarDadosGerais',
                :operacaoEditarOuClonar='operacaoEditarOuClonar'
            )

            FormularioAtividadeOperacao.mb-3(
                v-if='verificouSeEcadastroOuEdicao',
                @dadosAtividades='atualizarAtividades',
                :operacaoEditarOuClonar='operacaoEditarOuClonar',
                :atividadeObrigatoria='atividadeObrigatoria'
            )

            FormularioPessoaOperacao.mb-3(
                v-if='verificouSeEcadastroOuEdicao',
                @dadosPessoa='atualizarPessoa',
                :operacaoEditarOuClonar='operacaoEditarOuClonar'
            )

            FormularioTerritorioGlebaOperacao.mb-3(
                v-if='verificouSeEcadastroOuEdicao',
                @dadosTerritorioGleba='atualizarTerritorioGleba',
                :dadosEditarOuClonar='operacaoEditarOuClonar',
                :dadosValidarSobreposicao='validarSobreposicao'
            )

            .cadastro-operacao__acao
                el-button(size='small', @click='$router.go(-1)')
                    | Voltar

                el-button(
                    @click='realizarAnaliseSocioambiental()',
                    type='primary',
                    size='small'
                )
                    | Realizar Análise Socioambiental

    CardAnaliseSocioambientalOperacao(
        v-if='mostrarCardAnaliseSocioambiental',
        :editandoOperacao='!!$route.params.id && this.acao === "editar"',
        :dadosDiagnostico='dadosAnaliseSocioambientalProtocolo',
        @fechar='fecharCardAnaliseSocioambientalOperacao',
        @cadastrarOperacao='inserirOperacao'
    )
</template>

<script>
import BaseHeader from '@/components/BaseHeader';
import CardAnaliseSocioambientalOperacao from '@/components/operacao/gestao/CardAnaliseSocioambientalOperacao.vue';
import FormularioDadosGeraisOperacao from '@/components/operacao/gestao/FormularioDadosGeraisOperacao.vue';
import FormularioAtividadeOperacao from '@/components/operacao/gestao/FormularioAtividadeOperacao.vue';
import FormularioPessoaOperacao from '@/components/operacao/gestao/FormularioPessoaOperacao.vue';
import FormularioTerritorioGlebaOperacao from '@/components/operacao/gestao/FormularioTerritorioGlebaOperacao.vue';
import OperacaoService from '@/services/OperacaoService';
import ExceptionMapper from '@/utils/exceptionMapper';

export default {
    name: 'CadastroOperacao',
    components: {
        BaseHeader,
        CardAnaliseSocioambientalOperacao,
        FormularioDadosGeraisOperacao,
        FormularioAtividadeOperacao,
        FormularioPessoaOperacao,
        FormularioTerritorioGlebaOperacao
    },

    data() {
        return {
            operacaoEditarOuClonar: null,
            acao: '',
            validarSobreposicao: {
                idOperacao: null,
                idCategoria: null,
                datasPlantio: []
            },
            atividadeObrigatoria: true,
            dadosAnaliseSocioambientalProtocolo: {
                pessoas: [],
                territorios: [],
                glebas: []
            },
            operacao: {
                dadosGerais: null,
                atividades: [],
                pessoasGrupoEconomico: [],
                territoriosGlebas: []
            },
            verificouSeEcadastroOuEdicao: false,
            mostrarFormulariosOperacao: true,
            mostrarCardAnaliseSocioambiental: false
        };
    },

    async mounted() {
        // Edição de operação
        const idOperacao = this.$route.params.id;
        if (idOperacao) {
            try {
                const { data } = await OperacaoService.buscarPorId(idOperacao);
                this.operacaoEditarOuClonar = data;
                const acao = this.$route.params.acao;
                if (acao) {
                    this.acao = acao;
                }

                this.verificouSeEcadastroOuEdicao = true;
            } catch (error) {
                this.$notify.error({
                    message: error.message
                });
            }
        } else {
            this.verificouSeEcadastroOuEdicao = true;
        }
    },
    methods: {
        atualizarDadosGerais(dadosGerais) {
            this.operacao.dadosGerais = dadosGerais;
            if (this.operacao.dadosGerais.categoria) {
                this.atividadeObrigatoria =
                    this.operacao.dadosGerais.categoria.atividadeObrigatoria;
            }
            this.validarSobreposicao.idCategoria = dadosGerais.categoria.id;
        },

        atualizarPessoa(dadosPessoas) {
            this.operacao.pessoasGrupoEconomico = dadosPessoas;
        },

        atualizarAtividades(dadosAtividades) {
            this.operacao.atividades = dadosAtividades;
            this.validarSobreposicao.datasPlantio = [];
            this.operacao.atividades.forEach(atividade => {
                if (atividade.inicioPlantio) {
                    this.validarSobreposicao.datasPlantio.push(
                        atividade.inicioPlantio
                    );
                }
            });
        },

        atualizarTerritorioGleba(territoriosGlebas) {
            this.operacao.territoriosGlebas = territoriosGlebas;
        },

        identificarTituloCadastroOuEdicao() {
            this.validarSobreposicao.idOperacao = this.$route.params.id
                ? this.$route.params.id
                : null;
            return this.$route.params.id && this.acao === 'editar'
                ? 'Editar Operação'
                : 'Nova Operação';
        },

        async realizarAnaliseSocioambiental() {
            if (!(await this.validarFormularios())) return;

            this.dadosAnaliseSocioambientalProtocolo = {
                pessoas: [],
                territorios: []
            };

            const setPessoa = new Set();

            const pessoasUnicas = this.operacao.pessoasGrupoEconomico.filter(
                pessoa => {
                    const duplicada = setPessoa.has(pessoa.cpfCnpj);
                    setPessoa.add(pessoa.cpfCnpj);
                    return !duplicada;
                }
            );

            pessoasUnicas
                .map(e => ({
                    cpfCnpj: e.cpfCnpj,
                    nomeRazaoSocial: e.nomeRazaoSocial
                }))
                .forEach(e => {
                    this.dadosAnaliseSocioambientalProtocolo.pessoas.push(e);
                });

            this.operacao.territoriosGlebas.forEach(territorio => {
                const glebas = territorio.glebas.map(gleba => {
                    return {
                        utilizouAreaTotalTerritorio:
                            territorio.utilizouAreaTotalTerritorio,
                        geometria: gleba.geometria,
                        nome: gleba.nome
                    };
                });

                this.dadosAnaliseSocioambientalProtocolo.territorios.push({
                    idTerritorio: territorio.idTerritorio,
                    glebas
                });
            });

            this.mostrarFormulariosOperacao = false;
            this.mostrarCardAnaliseSocioambiental = true;
        },

        fecharCardAnaliseSocioambientalOperacao() {
            this.mostrarFormulariosOperacao = true;
            this.mostrarCardAnaliseSocioambiental = false;
        },

        async inserirOperacao() {
            if (!(await this.validarFormularios())) return;

            if (this.operacao.dadosGerais.valorTotalOperacao === 0) {
                this.operacao.dadosGerais.valorTotalOperacao = null;
            }

            if (
                this.operacaoEditarOuClonar !== null &&
                this.acao === 'editar'
            ) {
                await OperacaoService.editar(
                    this.operacao,
                    this.operacaoEditarOuClonar.dadosGerais.id
                )
                    .then(() => {
                        this.$notify.success({
                            message: 'Operação atualizada com sucesso.'
                        });
                        this.$router.push({ name: 'operacao' });
                    })
                    .catch(rsp => {
                        if (
                            rsp.response.data.exception ===
                            'OperacaoComIdentificadorDuplicadoException'
                        ) {
                            this.$notify.error({
                                message: rsp.response.data.message
                            });
                            return;
                        }

                        if (ExceptionMapper(rsp)) {
                            this.$notify.error({
                                message: rsp.response.data.message,
                                duration: 15000
                            });
                            return;
                        }

                        this.$notify.error({
                            message:
                                'Não foi possível continuar com o cadastro da operação. Favor verificar os dados inseridos e tentar novamente. Lembre-se de verificar os campos em que foram inseridos dados copiados de outras fontes. Se o problema persistir, favor entrar em contato com os administradores da plataforma.',
                            duration: 15000
                        });
                    });
            } else {
                await OperacaoService.inserir(this.operacao)

                    .then(() => {
                        this.$notify.success({
                            message: 'Operação cadastrada com sucesso.'
                        });

                        this.$router.push({ name: 'operacao' });
                    })
                    .catch(rsp => {
                        if (
                            rsp.response.data.exception ===
                            'OperacaoComIdentificadorDuplicadoException'
                        ) {
                            this.$notify.error({
                                message: rsp.response.data.message
                            });
                            return;
                        }

                        this.$notify.error({
                            message:
                                'Não foi possível continuar com o cadastro da operação. Favor verificar os dados inseridos e tentar novamente. Lembre-se de verificar os campos em que foram inseridos dados copiados de outras fontes. Se o problema persistir, favor entrar em contato com os administradores da plataforma.',
                            duration: 15000
                        });
                    });
            }
        },

        async validarFormularios() {
            if (
                !(await this.$refs.refFormularioDadosGerais.validarFormulario())
            ) {
                this.$notify.warning({
                    message:
                        'Preencha informações obrigatórias dos dados gerais.'
                });
                return false;
            }

            if (
                this.operacao.atividades.length === 0 &&
                this.operacao.dadosGerais.categoria.id < 4
            ) {
                this.$notify.warning({
                    message: 'Preencha informações obrigatórias de atividades.'
                });
                return false;
            }

            if (this.operacao.pessoasGrupoEconomico.length === 0) {
                this.$notify.warning({
                    message:
                        'Preencha informações obrigatórias de pessoas / grupo econômico.'
                });
                return false;
            }

            if (this.operacao.territoriosGlebas.length === 0) {
                this.$notify.warning({
                    message:
                        'É obrigatório cadastrar pelo menos uma gleba em cada um dos territórios adicionados.'
                });
                return false;
            }

            return true;
        }
    }
};
</script>

<style lang="scss" scoped>
#cadastro-operacao {
    height: 100%;
    width: 100%;

    .cadastro-operacao__acao {
        display: flex;
        align-items: center;
        justify-content: space-between;
    }
}
</style>
